/*jslint browser: true, plusplus: true, vars: true */
/*global jQuery: false */

/*
 * equalHeight equalizes the heights of elements in a jQuery collection.
 * By Hans Mogren <hans.mogren@spotonsolutions.se>.
 * Inspired by jquery.equalizecols.js by Tom Deater (http://www.tomdeater.com/jquery/equalize_columns/).
 * Usage: $("p").equalHeight(options);
 * Licensed under the MIT License:
 * http://www.opensource.org/licenses/mit-license.php
 */

(function ($, window) {

	"use strict";

	$.fn.equalHeight = function (options) {

		var $this = this,
		    $window = $(window),
			settings = $.extend({}, $.fn.equalHeight.defaults, options);

		var delay = (function () {
			var timer = 0;
			return function (callback, ms) {
				clearTimeout(timer);
				timer = setTimeout(callback, ms);
			};
		}());

		// Equalizes the heights of the supplied set of elements.
		var equalize = function (set) {

			var height = 0;

			var setMaxHeight = function () {
				height = Math.max(height, this.offsetHeight);
			};

			var finalizeHeight = function () {

				var elementHeight = this.offsetHeight;

				if (elementHeight > height) {
					$(this).css("height", height - (elementHeight - height));
				}
			};

			set
				.css("height", "auto")
				.each(setMaxHeight)
				.css("height", height)
				.each(finalizeHeight);
		};

		// Cluster the set of elements and equalize the heights of all elements in each cluster.
		var equalizeByCluster = function (set) {

			var start = 0,
				end = 0,
				clusters = Math.ceil(set.length / settings.cluster),
				i;

			for (i = 0; i < clusters; i++) {
				end += settings.cluster;
				equalize(set.slice(start, end));
				start = end;
			}
		};

		// Cluster the elements and equalize the heights of all elements in each cluster.
		var equalizeSequentiallyByPosition = function (set) {

			var first, top, cluster, rest;

			if (set && set.length > 0) {

				first = set[0];
				top = $(first).offset().top;
				cluster = [first];

				set.slice(1).each(function () {
					if (top === (top = $(this).offset().top)) {
						cluster.push(this);
					} else {
						return false;
					}
					return true;
				});

				rest = set.slice(cluster.length);
				equalize($(cluster));

				if (rest.length) {
					equalizeSequentiallyByPosition(rest);
				}
			}
		};

		// Cluster the elements and equalize the heights of all elements in each cluster.
		var equalizeAllByPosition = function (set) {

			var clusters = [];

			var getClusterByPosition = function (top) {

				var cluster, i;

				for (i = 0; cluster = clusters[i]; i++) {

					if (cluster.top === top) {
						return cluster;
					}
				}

				return null;
			};

			set.each(function (idx, node) {

				var elem = $(node);
				var top = parseInt(elem.offset().top, 10);
				var cluster = getClusterByPosition(top);

				if (cluster !== null) {
					cluster.elements.push(elem[0]);
				} else {
					clusters.push({
						"top": top,
						"elements": [elem[0]]
					});
				}
			});

			$.each(clusters, function (idx, cluster) {
				equalize($(cluster.elements));
			});
		};

		var main = function () {

			if (settings.cluster) {
				if (settings.cluster === "auto") {
					equalizeAllByPosition($this);
				} else if (settings.cluster === "sequentially") {
					equalizeSequentiallyByPosition($this);
				} else {
					equalizeByCluster($this);
				}
			} else {
				equalize($this);
			}

			settings.callback();
		};

		if (settings.imagesLoaded) {
			$this.imagesLoaded(main);
		} else {
			main();
		}

		// Resize after the window has been resized.
		if (settings.onResize) {

			var onResize = function () {
				delay(main, settings.resizeInterval);
			};

			$(window).bind("resize.equalheight", onResize);
		}

		return $this;
	};

	// Default settings.
	$.fn.equalHeight.defaults = {
		callback: $.noop,
		cluster: "auto", // If set equalizes the heights of the elements in clusters. The default is "auto" which means that the clusters will be automatically created by examining the position of the elements. A positive integer defines the cluster size, i.e. how many elements will be compared against each other. If the value is falsy all elements will be compared against each other.
		onResize: true, // Re-calculate the heights when the window is resized.
		resizeInterval: 40, // Resize interval.
		imagesLoaded: false // Use the jquery.imagesloaded.js plugin (which must be loaded) to wait for images to be loaded before trying to set the height. See https://github.com/desandro/imagesloaded/blob/master/jquery.imagesloaded.js for more info.
	};

}(jQuery, window));